import React, { useContext, useState } from 'react';
import {ModuloContext, SellerContext, SellerData} from '../context/seller_context';
import '../assets/styles/search_seller_by_document.css';
import image2 from '../assets/images/icons/2-validar-informacion.png';
import {useNavigate} from "react-router-dom";
import {MyContext} from "../context/my_context";

const SearchSellerByDocument = () => {
    const sellerContext = useContext(SellerContext);
    const moduloContext = useContext(ModuloContext);
    const navigate = useNavigate();
    const { module } = moduloContext!;
    const {setSeller } = sellerContext!;
    const context = useContext(MyContext);

    if (!context) {
        throw new Error("UserProfile must be used within a MyProvider");
    }

    const { userData } = context;

    // Local state to store the input value
    const [documentNumber, setDocumentNumber] = useState<string>('');

    console.log ('documentNumber:', documentNumber);

    // Method to handle the search
    const handleSearch = async () => {
        if (!documentNumber) {
            alert('Por favor, ingrese un número de documento');
            return;
        }

        if (!sellerContext || !userData?.token) return;

        try {
            // Main or development backend URL
            const apiUrl = process.env.NODE_ENV === 'development'
                ? `${process.env.REACT_APP_BACK_DEV}/ventero-completo/${documentNumber}`
                : `${process.env.REACT_APP_BACK_URL}/ventero-completo/${documentNumber}`;

            // First attempt: query to main or development backend
           // const response = await fetch(apiUrl);
            const mainResponse = await fetchWithFallback(apiUrl, userData.token);
            processResponseData(mainResponse, 'Principal');

            if (!mainResponse.ok) {
                throw new Error(`HTTP error! status: ${mainResponse.status}`);
            }

            const data = await mainResponse.json();
            console.log('Datos desde backend principal:', data);
            setSeller(data);
        } catch (error) {
            console.error("Error en backend principal, intentando con backend local:", error);
        }
    };

    // Auxiliary method to fetch data with error handling
    const fetchWithFallback = async (url: string, token: string) => {
        const response = await fetch(url, {
            headers: {
                'x-access': token,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (!data.success) {
            throw new Error(data.message || 'Error en los datos recibidos');
        }

        return data;
    };

    // Method to process the response data
    const processResponseData = (data: any, source: string) => {

        // console.log(`Datos desde el backend ${source}:`, data);

        const personaData = data.persona?.entities?.persona?.[documentNumber] || {};
        const venteroData = data.ventero?.entities?.ventero?.[documentNumber] || {};

        /*
        console.log('Detalles:', {
            venteroId: documentNumber,
            personaData,
            venteroData,
            fotoUrl: venteroData.enlace
        });
         */

        const sellerData: SellerData = {
            nombre_completo: `${personaData.nombre1 || ''} ${personaData.apellido1 || ''}`.trim(),
            id_tipo_documento: personaData.idTipoDocumento?.toString() || '',
            documento: personaData.documento || '',
            correo_electronico: personaData.correoElectronico || '',
            actividad: venteroData.actividad || '',
            fecha_vencimiento: venteroData.fechaVencimiento || '',
            numero_resolucion: venteroData.numeroResolucion || '',
            foto_ventero: venteroData.enlace || '',
            telefono: personaData.telefonoCelular || module?.telefonoCelular || null
        };

        setSeller(sellerData);
        navigate('/seller_profile');
    };

    if (!moduloContext) {
        return <div>Error: ModuloContext no está definido</div>;
    }

    return (
        <div className="search-seller-container">
            <div className="icon-container">
                <div className="search-icon">
                    <img src={image2} alt="Lock icon" className="icon" />
                </div>
                <div className="search-container">
                    <h2>Buscar Ventero Por Número De Documento</h2>
                    <div className="search-input">
                        <div className="input-wrapper">
                            <i className="fa-regular fa-address-card icon-inside"></i>
                            <input
                                type="text"
                                id="documentNumber"
                                placeholder="Ingrese número de documento"
                                value={documentNumber}
                                onChange={(e) => setDocumentNumber(e.target.value)} // Update the state when the input changes
                            />
                        </div>
                        <div className="search-button-cont">
                            <button className="search-button" onClick={handleSearch}>Buscar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchSellerByDocument;